<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="700"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form >
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>廃棄物の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- マニフェスト番号 -->
            <v-row v-if="forms.manifest_type !== 'dxe_form'">
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="マニフェスト番号"
                  :rules="{numeric: true, length: 11}"
                >
                  <v-text-field
                    v-model="forms.manifest_no"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="マニフェスト番号"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>マニフェスト番号</span>
                      <span class="ml-1">
                        ({{ forms.manifest_no?.length || 0 }} / 11)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /マニフェスト番号 -->

            <!-- 取扱品目 -->
            <v-row>
              <v-col cols="12">
                <div class="fieldsetLabel">
                  <fieldset>
                    <legend>取扱品目</legend>
                    <span>{{ forms.item_name }}&nbsp;</span>
                  </fieldset>
                </div>
              </v-col>
            </v-row>
            <!-- /取扱品目 -->
            <!-- 廃棄物の名称 -->
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="廃棄物の名称"
                  rules="max:30"
                >
                  <v-text-field
                    v-model="forms.waste_name"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="廃棄物の名称"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>廃棄物の名称</span>
                      <span class="ml-1">
                        ({{ forms.waste_name?.length || 0 }} / 30)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /廃棄物の名称 -->

            <!-- 数量・数量の確定者-->
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :class="(forms.manifest_type === 'dxe_form' && forms.quantity_confirm_id === 2) || forms.quantity_unit_id > 0 ? 'requiredMark' : ''"
                  :custom-messages="customMessages"
                  :rules="{ required: (forms.manifest_type === 'dxe_form' && forms.quantity_confirm_id === 2) || forms.quantity_unit_id > 0, double: true, min_value: 0.001, max_value: 99999.999, quantityWithDecimal: { int_digits: 5, dec_digits: 3 } }"
                  name="数量"
                >
                  <v-text-field
                    v-model="forms.quantity"
                    :error-messages="errors"
                    :show-size="1000"
                    dense
                    label="数量"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    reverse
                    type="number"
                    @keydown.69.prevent
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :class="(forms.manifest_type === 'dxe_form' && forms.quantity_confirm_id === 2) || forms.quantity > 0 ? 'requiredMark' : ''"
                  :rules="{ required: (forms.manifest_type === 'dxe_form' && forms.quantity_confirm_id === 2) || forms.quantity > 0 }"
                  name="数量単位"
                >
                  <v-select
                    v-model="forms.quantity_unit_id"
                    :error-messages="errors"
                    :items="quantityUnits"
                    clearable
                    dense
                    hide-details="auto"
                    label="数量単位"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="5"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :class="forms.manifest_type === 'dxe_form' ? 'requiredMark' : '' "
                  :rules="{ required: forms.manifest_type === 'dxe_form' }"
                  name="数量の確定者"
                >
                  <v-select
                    v-model="forms.quantity_confirm_id"
                    :error-messages="errors"
                    :items="quantityConfirms"
                    clearable
                    dense
                    hide-details="auto"
                    label="数量の確定者"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /数量・数量の確定者-->
            <!-- 荷姿 -->
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :class="forms.manifest_type === 'dxe_form' ? 'requiredMark' : ''"
                  :rules="{ required: forms.manifest_type === 'dxe_form' }"
                  name="荷姿"
                >
                  <v-select
                    v-model="forms.packing_id"
                    :error-messages="errors"
                    :items="packings"
                    clearable
                    dense
                    hide-details="auto"
                    label="荷姿"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                  name="荷姿の数量"
                >
                  <v-text-field
                    v-model="forms.packing_quantity"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="荷姿の数量"
                    outlined
                    reverse
                    persistent-placeholder
                    type="number"
                    @keydown.69.prevent
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /荷姿 -->

            <!-- 有害物質 -->
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    duplicateKeys: { keys: [
                      forms.hazardous_substance_2_id,
                      forms.hazardous_substance_3_id,
                      forms.hazardous_substance_4_id,
                      forms.hazardous_substance_5_id,
                      forms.hazardous_substance_6_id
                    ] }
                  }"
                  name="有害物質1"
                >
                  <v-select
                    v-model="forms.hazardous_substance_1_id"
                    :disabled="!forms.can_edit_hazardous_substance"
                    :error-messages="errors"
                    :items="hazardousSubstances"
                    clearable
                    dense
                    hide-details="auto"
                    label="有害物質１"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    duplicateKeys: { keys: [
                      forms.hazardous_substance_1_id,
                      forms.hazardous_substance_3_id,
                      forms.hazardous_substance_4_id,
                      forms.hazardous_substance_5_id,
                      forms.hazardous_substance_6_id
                    ] }
                  }"
                  name="有害物質2"
                >
                  <v-select
                    v-model="forms.hazardous_substance_2_id"
                    :disabled="!forms.can_edit_hazardous_substance"
                    :error-messages="errors"
                    :items="hazardousSubstances"
                    clearable
                    dense
                    hide-details="auto"
                    label="有害物質２"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    duplicateKeys: { keys: [
                      forms.hazardous_substance_1_id,
                      forms.hazardous_substance_2_id,
                      forms.hazardous_substance_4_id,
                      forms.hazardous_substance_5_id,
                      forms.hazardous_substance_6_id
                    ] }
                  }"
                  name="有害物質3"
                >
                  <v-select
                    v-model="forms.hazardous_substance_3_id"
                    :disabled="!forms.can_edit_hazardous_substance"
                    :error-messages="errors"
                    :items="hazardousSubstances"
                    clearable
                    dense
                    hide-details="auto"
                    label="有害物質３"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    duplicateKeys: { keys: [
                      forms.hazardous_substance_1_id,
                      forms.hazardous_substance_2_id,
                      forms.hazardous_substance_3_id,
                      forms.hazardous_substance_5_id,
                      forms.hazardous_substance_6_id
                    ] }
                  }"
                  name="有害物質4"
                >
                  <v-select
                    v-model="forms.hazardous_substance_4_id"
                    :disabled="!forms.can_edit_hazardous_substance"
                    :error-messages="errors"
                    :items="hazardousSubstances"
                    clearable
                    dense
                    hide-details="auto"
                    label="有害物質４"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    duplicateKeys: { keys: [
                      forms.hazardous_substance_1_id,
                      forms.hazardous_substance_2_id,
                      forms.hazardous_substance_3_id,
                      forms.hazardous_substance_4_id,
                      forms.hazardous_substance_6_id
                    ] }
                  }"
                  name="有害物質5"
                >
                  <v-select
                    v-model="forms.hazardous_substance_5_id"
                    :disabled="!forms.can_edit_hazardous_substance"
                    :error-messages="errors"
                    :items="hazardousSubstances"
                    clearable
                    dense
                    hide-details="auto"
                    label="有害物質５"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    duplicateKeys: { keys: [
                      forms.hazardous_substance_1_id,
                      forms.hazardous_substance_2_id,
                      forms.hazardous_substance_3_id,
                      forms.hazardous_substance_4_id,
                      forms.hazardous_substance_5_id
                    ] }
                  }"
                  name="有害物質6"
                >
                  <v-select
                    v-model="forms.hazardous_substance_6_id"
                    :disabled="!forms.can_edit_hazardous_substance"
                    :error-messages="errors"
                    :items="hazardousSubstances"
                    clearable
                    dense
                    label="有害物質６"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /有害物質 -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditWasteDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestId: {
      type: Number,
      default: () => null,
    },
    packings: {
      type: Array,
      default: () => [],
    },
    quantityUnits: {
      type: Array,
      default: () => [],
    },
    quantityConfirms: {
      type: Array,
      default: () => [],
    },
    hazardousSubstances: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
      canShowHazardous: false,
      forms: {
        id: null,
        manifest_type: null,
        manifest_no: null,
        item_id: null,
        // item_name: null,
        waste_name: null,
        packing_id: null,
        packing_quantity: null,
        quantity: null,
        quantity_unit_id: null,
        quantity_confirm_id: null,
        can_edit_hazardous_substance: false,
        hazardous_substance_1_id: null,
        hazardous_substance_2_id: null,
        hazardous_substance_3_id: null,
        hazardous_substance_4_id: null,
        hazardous_substance_5_id: null,
        hazardous_substance_6_id: null
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementWaste', {
      fetchWaste: 'edit',
      updateWaste: 'update',
    }),
    ...mapActions("DriverManifestManagementVerifyWaste", {
      verifyWaste: "update",
    }),
    setVariable() {
      this.fetchWaste({ id: this.manifestId }).then((content) => {
        this.forms = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyWaste({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateWaste({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      let params = {
        packing_id: this.forms.packing_id,
        waste_name: this.forms.waste_name,
        packing_quantity: this.forms.packing_quantity,
        quantity: this.forms.quantity,
        quantity_unit_id: this.forms.quantity_unit_id,
        quantity_confirm_id: this.forms.quantity_confirm_id,
        hazardous_substance_1_id: this.forms.hazardous_substance_1_id,
        hazardous_substance_2_id: this.forms.hazardous_substance_2_id,
        hazardous_substance_3_id: this.forms.hazardous_substance_3_id,
        hazardous_substance_4_id: this.forms.hazardous_substance_4_id,
        hazardous_substance_5_id: this.forms.hazardous_substance_5_id,
        hazardous_substance_6_id: this.forms.hazardous_substance_6_id,
      }
      return params;
    },
  }
}
</script>
